<template>
    <div class="card shadow"
         :class="type === 'dark' ? 'bg-default': ''">
        <div class="card-header border-0"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
                        Fragebögen
                    </h3>
                </div>
                <div class="col text-right">
                    <base-button type="primary" size="sm" v-on:click="$router.push('/forms/create')">hinzufügen</base-button>
                </div>
            </div>
        </div>

        <div class="table-responsive">
            <base-table class="table align-items-center table-flush"
                        :class="type === 'dark' ? 'table-dark': ''"
                        :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                        tbody-classes="list"
                        :data="tableData">
                <template slot="columns">
                    <th>id</th>
                    <th>Name</th>
                    <th>Beschreibung</th>
                    <th>Erstellt von</th>
                    <th>am</th>
                    <th>Aktiv</th>
                    <th></th>
                </template>

                <template slot-scope="{row}">
                    <th scope="row">
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{row.id}}</div>
                    </th>
                    <td>
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{row.name}}</div>
                    </td>
                    <td v-html="row.description">
                    </td>
                    <td>
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{(row.user) ? row.user.firstname+' '+row.user.lastname+'' : '-'}}</div>
                    </td>
                    <td>
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{ row.createdAt | formatDateToDay }}</div>
                    </td>
                    <td>
                        <badge class="badge-dot mr-4" :type="(row.isActive) ? 'success' : 'danger'">
                            <i :class="`bg-${(row.isActive) ? 'success' : 'danger'}`"></i>
                            <span class="status">{{(row.isActive) ? 'aktiv' : 'inaktiv'}}</span>
                        </badge>
                    </td>
                    <td class="text-right"><div v-if="isLoading" class="loading-button"> </div><div v-else>
                        <base-dropdown class="dropdown"
                                       position="right">
                            <a slot="title" class="btn btn-sm btn-icon-only text-light" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i class="fas fa-ellipsis-v"></i>
                            </a>
                            <template>
                                <router-link class="dropdown-item" :to="'/forms/edit/'+row.id">Anzeigen und editieren</router-link>
                            </template>
                        </base-dropdown></div>
                    </td>
                </template>
            </base-table>
        </div>

        <div class="card-footer d-flex justify-content-end"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <base-pagination :total="totalitems" v-on:input="changePage" :value="page"></base-pagination>
        </div>

    </div>
</template>

<script>
    export default {
        name: "list",
        props: {
            type: {
                type: String
            },
            title: String
        },
        data() {
            return {
                tableData: [
                    {
                        id: 0,
                        name: "",
                        description: "",
                        user: 0,
                        createdAt: '',
                        isActive: true
                    }
                ],
                totalitems: 0,
                page: 1,
                isLoading: false,
            }
        },
        created() {
          this.changePage(this.page);
        },
        computed: {
            isAdmin() {
                return this.$store.getters['authentication/isAdmin'];
            }
        },
        methods: {
            changePage(page) {
                this.isLoading = true;
                this.getTableData(page).then(
                    response => {
                        this.tableData = response.member;
                        this.totalitems = response.totalItems;
                        this.page = page;
                        this.isLoading = false;
                    }
                )
            },
            getTableData(page){
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header
                    };

                    fetch(process.env.VUE_APP_API_SERVER + `/api/forms?page=` + page, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                            resolve({
                                totalItems: response['hydra:totalItems'],
                                member: response['hydra:member']
                            });
                        }, error => {reject(error); });
                });
            }
        }
    }
</script>

<style scoped>

</style>